module.exports = __webpack_public_path__ + "img/gb9122_1_l.prt.0e5213b6.jpg";